import { render } from "./SpuInfo.vue?vue&type=template&id=572182f0&scoped=true"
import script from "./SpuInfo.vue?vue&type=script&lang=js"
export * from "./SpuInfo.vue?vue&type=script&lang=js"

import "./SpuInfo.vue?vue&type=style&index=0&id=572182f0&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572182f0"]])

export default __exports__